import { render, staticRenderFns } from "./paipanRecord.vue?vue&type=template&id=ec01f068&scoped=true"
import script from "./paipanRecord.vue?vue&type=script&lang=js"
export * from "./paipanRecord.vue?vue&type=script&lang=js"
import style0 from "./paipanRecord.vue?vue&type=style&index=0&id=ec01f068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec01f068",
  null
  
)

export default component.exports